import { DatePipe } from "@angular/common";
import { Component, Input } from "@angular/core";
import { Support, SupportStatus } from "@models/support";
import { SupportStatusPipe } from "../../../shared/pipes/support-status.pipe";

@Component({
  selector: "app-support-info-card",
  imports: [DatePipe, SupportStatusPipe],
  templateUrl: "./support-info-card.component.html",
  styleUrl: "./support-info-card.component.scss",
})
export class SupportInfoCardComponent {
  readonly SupportStatus = SupportStatus;

  @Input({ required: true }) support!: Support;
}
